import { useCallback, useContext, useEffect } from 'react';
import { AuthContext } from 'react-oidc-context';
import { useIntl } from 'react-intl';
import { useDataProvider } from '@ui-framework/providers/DataProvider';
import { useSnackbar } from '@ui-framework/providers/SnackbarProvider';
import { useStore } from '@ui-framework/providers/MobxProvider';

function NotificationStreamConnection() {
  // OIDC is mounted only after the user selects their login configuration.
  const isAuthenticated = useContext(AuthContext)?.isAuthenticated ?? false;
  const store = useStore();
  const provider = useDataProvider(
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default',
  );
  const inboxStore = store.uiState.notificationInboxStore;
  const { formatMessage } = useIntl();
  const snackbar = useSnackbar();
  const onStreamError = useCallback(
    error => {
      if (error?.status === 403) {
        snackbar.showMessage({
          type: 'error',
          data: formatMessage({
            id: 'NOTIFICATIONS_STREAM_FORBIDDEN',
            defaultMessage:
              'You do not have permission to receive live notifications.',
          }),
        });
      }
    },
    [formatMessage, snackbar],
  );

  useEffect(() => {
    if (!isAuthenticated) {
      inboxStore.clearStore();
      return undefined;
    }

    inboxStore.connect(provider, onStreamError);
    return () => inboxStore.clearStore();
  }, [inboxStore, isAuthenticated, onStreamError, provider]);

  return null;
}

export default NotificationStreamConnection;
